import React, { FC, useCallback, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DropDownMenu } from './DropDownMenu';
import { DISPLAY_TYPE_LIST, DISPLAY_TYPE_MINIMAL, DISPLAY_TYPE_TILE, DisplayType } from './displayType/types';
import { useDisplayTypeSearchParam } from '../utils/useDisplayTypeSearchParam';

const displayTypesAndIcons = {
    [DISPLAY_TYPE_MINIMAL]: {
        icon: 'view_module',
        label: 'coverView'
    },
    [DISPLAY_TYPE_TILE]: {
        icon: 'view_column',
        label: 'coverDetailView'
    },
    [DISPLAY_TYPE_LIST]: {
        icon: 'dehaze',
        label: 'listDetailView'
    }
};

type Props = {
    readonly displayType: DisplayType;
    readonly floatRight?: boolean;
    readonly className?: string;
    readonly excludeDisplayTypes?: ReadonlyArray<DisplayType>;
};

const DisplayTypeDropDown: FC<Props> = ({ displayType, floatRight = true, className, excludeDisplayTypes = [] }) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const { onDisplayChange } = useDisplayTypeSearchParam();

    const onChange = useCallback(
        (newType: DisplayType) => {
            onDisplayChange(newType);
            setExpanded(false);
        },
        [onDisplayChange]
    );

    const mainClasses = classNames(className, 'display-type', 'dd-a-r', floatRight && 'fl-right');
    const { icon, label } = displayTypesAndIcons[displayType];

    return (
        <DropDownMenu
            expanded={expanded}
            onToggleClick={setExpanded}
            onClickOutside={setExpanded}
            align={floatRight ? 'right' : 'left'}
            iconCode={icon}
            iconSizeClass="md-upper"
            label={t(`components.displayTypeDropdown.${label}`)}
            className={mainClasses}
            btnInnerClassName="bt-inner"
            arrowClassName="up arrow fl-right"
        >
            {Object.keys(displayTypesAndIcons)
                .filter(it => !excludeDisplayTypes.includes(it as DisplayType))
                .map(type => {
                    const isActive = type === displayType;
                    const { icon, label } = displayTypesAndIcons[type];
                    return (
                        <li key={type}>
                            <a
                                className={isActive ? 'checked' : undefined}
                                onClick={() => onChange(type as DisplayType)}
                            >
                                <i className="material-icons">{icon}</i>&nbsp;
                                {t(`components.displayTypeDropdown.${label}`)}
                                {isActive && <i className="material-icons">check</i>}
                            </a>
                        </li>
                    );
                })}
        </DropDownMenu>
    );
};

export default DisplayTypeDropDown;
